import { createApi } from "@reduxjs/toolkit/query/react";
import { ActivityLog } from "@convin/type/Activity";
import { getDomain } from "@convin/utils/helper/common.helper";
import apiConfigs from "@convin/config/api.config";
import axiosBaseQuery from "../axiosBaseQuery";

const protocol = import.meta.env.VITE_APP_API_PROTOCOL ?? apiConfigs.HTTPS;
const api = import.meta.env.VITE_APP_ACTIVITY_LOG_SERVICE_URL;

const baseApi = api
    ? `${protocol}${api}/`
    : "https://activity-log.convin.ai/v1/";

export const activityApiSlice = createApi({
    reducerPath: "activityApiSlice",
    baseQuery: axiosBaseQuery({
        baseUrl: `${baseApi}${getDomain()}`,
    }),
    endpoints: (builder) => ({
        getActivityLogs: builder.query<
            {
                logs: ActivityLog[];
                last_evaluated_key: string;
            },
            {
                last_evaluated_key?: string;
                filter: string;
            }
        >({
            query: ({ last_evaluated_key, filter }) => ({
                url: "activity_logs/",
                method: "POST",
                body: {
                    filter,
                    last_evaluated_key: last_evaluated_key,
                    page_size: 20,
                },
            }),
            keepUnusedDataFor: 0,
        }),
    }),
});

export const { useGetActivityLogsQuery, useLazyGetActivityLogsQuery } =
    activityApiSlice;
